/* eslint-disable no-useless-escape */
/* eslint-disable @typescript-eslint/no-explicit-any */
const charCodeOffset = (offset: any) => (
  (c: any): string => String.fromCharCode(c.charCodeAt(0) + offset)
);

const normalizeString = (value: string, ...types: string[]): string => {
  let normalizedValue = value.normalize('NFKC').trim();
  if (types.includes('zenkaku')) {
    normalizedValue = normalizedValue
      .replace(/[A-Za-z0-9!-~]/g, charCodeOffset(0xFEE0))
      .replace(/[‐－―−]/g, 'ー')
      .replace(/[～]/g, '〜')
      .replace(/ /g, '　');
  }
  if (types.includes('kana')) {
    normalizedValue = normalizedValue.replace(/[ぁ-ゔ]/g, charCodeOffset('ア'.charCodeAt(0) - 'あ'.charCodeAt(0)));
  }
  if (types.includes('email') || types.includes('phoneNumber')) {
    normalizedValue = normalizedValue.replace(/[Ａ-Ｚａ-ｚ０-９]/g, charCodeOffset('A'.charCodeAt(0) - 'Ａ'.charCodeAt(0)));
  }
  if (types.includes('email')) {
    normalizedValue = normalizedValue.replace(/[A-Z]/g, charCodeOffset('a'.charCodeAt(0) - 'A'.charCodeAt(0)));
  }
  if (types.includes('email')) {
    normalizedValue = normalizedValue.replace(/[＠]/g, charCodeOffset('@'.charCodeAt(0) - '＠'.charCodeAt(0)));
  }
  if (types.includes('email')) {
    normalizedValue = normalizedValue.replace(/[．]/g, charCodeOffset('.'.charCodeAt(0) - '．'.charCodeAt(0)));
  }
  if (types.includes('number')) {
    normalizedValue = normalizedValue.replace(/[０-９]/g, charCodeOffset('1'.charCodeAt(0) - '１'.charCodeAt(0)));
  }
  if (types.includes('phoneNumber')) {
    normalizedValue = normalizedValue.replace(/[^0-9]/g, '');
  }
  if (types.includes('zipCode')) {
    normalizedValue = normalizedValue
      .replace(/[０-９]/g, charCodeOffset('1'.charCodeAt(0) - '１'.charCodeAt(0)))
      .replace(/[‐－―−ー]/g, '-');
  }
  return normalizedValue;
};

export const normalizeZipCode = (zipCode: string):string => normalizeString(zipCode, 'number').replace(/[‐－―−ー-]/g, '');

export default normalizeString;

// eslint-disable-next-line max-len
export const normalizeString2 = (value: string, types: string[]): string => normalizeString(value, ...types);
